module.exports = __webpack_public_path__ + "static/media/salesrep.25a5f60a.jpeg";